import PropTypes from 'prop-types'

import { Icon } from '../display/icon'

const ResumeIcon = ({ label = 'Resume', ...rest }) => {
  return (
    <Icon
      label={label}
      {...rest}
      dangerouslySetGlyph={`<svg data-name="Layer 1" viewBox="0 0 300 300"><rect x="52.3" y="28.3" width="195.5" height="245.07" rx="6.3" style="fill:#b1ce5f"/><path d="M241.4 28.3a6.3 6.3 0 0 1 6.3 6.3v232.5a6.3 6.3 0 0 1-6.3 6.3H58.6a6.3 6.3 0 0 1-6.3-6.3V34.6a6.3 6.3 0 0 1 6.3-6.3h182.8m0-9.8H58.6a16.2 16.2 0 0 0-16.1 16.1v232.5a16.2 16.2 0 0 0 16.1 16.1h182.8a16.2 16.2 0 0 0 16.1-16.1V34.6a16.2 16.2 0 0 0-16.1-16.1z" style="fill:#1d1d1b"/><path style="fill:#010101" d="M84.2 137.4h45.6v8.28H84.2zm77.5 8.3h-8.3v-8.3h8.3zm-16.6 0h-8.2v-8.3h8.2zm-19.5-49.9h-8.2v-8.2h8.2zm-16.5 0h-8.3v-8.2h8.3zm-16.6 0h-8.3v-8.2h8.3zM84.2 154h45.6v8.28H84.2zm92.2 8.3H170V154h6.4zm-14.7 0h-8.3V154h8.3zm-16.6 0h-8.2V154h8.2zm-60.9 8.3h32.5v8.28H84.2zm97.5 8.3h-8.3v-8.3h8.3zm-16.6 0h-8.2v-8.3h8.2zm-16.5 0h-8.3v-8.3h8.3zm-16.6 0h-8.2v-8.3h8.2z"/><path d="M213.5 65A10.5 10.5 0 1 1 224 54.5 10.5 10.5 0 0 1 213.5 65z" style="fill:#fff"/><path d="M213.5 70A15.5 15.5 0 1 1 229 54.5 15.4 15.4 0 0 1 213.5 70zm0-21a5.5 5.5 0 0 0-5.4 5.5 5.5 5.5 0 1 0 10.9 0 5.5 5.5 0 0 0-5.5-5.5z" style="fill:#1d1d1b"/></svg>`}
    />
  )
}

ResumeIcon.propTypes = {
  onClick: PropTypes.func,
  label: PropTypes.string,
  color: PropTypes.string,
  size: PropTypes.oneOf(['tiny', 'small', 'medium', 'large'])
}

export { ResumeIcon }
